<template>
    <div>
        <!-- Begin Page Content -->
        <div class="make-appointment">
            <div class="row">
                <div class="col-lg-7 col-12 mb-4">
                    <div class="card border-0 bg-white border-radius-5 h-100">
                        <div class="card-header d-flex justify-content-center align-items-center border-0 bg-white p-3">
                            <div class="text-center w-100">
                                <h1 class="p-3">Make an Appointment</h1>
                                <form class="form-search Appointment-form position-relative">
                                    <button class="btn button search"><i class="icon icon-search"></i></button>
                                    <input type="text" name="text" placeholder="Search Question" />
                                    <ul class="d-flex searches justify-content-center mt-1">
                                        <li>Popular searches:</li>
                                        <li class="active"><a href="#">Diabetes,</a></li>
                                        <li><a href="#">Hypertension,</a></li>
                                        <li><a href="#">Nutritionist,</a></li>
                                        <li><a href="#">PCOS,</a></li>
                                    </ul>
                                </form>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row no-gutters">
                                <div class="col-lg-4 col-md-4 col-sm-12 pr-2">
                                    <div class="card border-1 border-radius-8 bg-white h-100 p-0">
                                        <div class="dr-profile border-1 pb-0 border-radius-8">
                                            <div class="doctor-details d-flex mb-3 p-2">
                                                <figure class="text-center">
                                                    <router-link to="/doctor-profile"><img class="mb-4" src="../../../../static/website/images/dr-image.svg" alt="" /></router-link> <i class="icon icon-video"></i>
                                                </figure>
                                                <div>
                                                    <h3>Dr. Shabnam Das Kar</h3>
                                                    <h5>MD, FMNM | 10 Years Exp</h5>
                                                    <p>Specialist in Functional and Metabolic Medicine</p>
                                                </div>
                                            </div>
                                            <router-link to="/calendy-calendar" class="btn btn-link btn-blue appointment-button">Book an Appointment</router-link >
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-4 col-sm-12 pr-2">
                                    <div class="card border-1 border-radius-8 bg-white h-100 p-0">
                                        <div class="dr-profile border-1 pb-0 border-radius-8">
                                            <div class="doctor-details d-flex mb-3 p-2">
                                                <figure class="text-center">
                                                    <router-link to="/doctor-profile"><img class="mb-4" src="../../../../static/website/images/dr-image.svg" alt="" /></router-link> <i class="icon icon-video"></i>
                                                </figure>
                                                <div>
                                                    <h3>Dr. Shabnam Das Kar</h3>
                                                    <h5>MD, FMNM | 10 Years Exp</h5>
                                                    <p>Specialist in Functional and Metabolic Medicine</p>
                                                </div>
                                            </div>
                                            <router-link to="/calendy-calendar" class="btn btn-link btn-blue appointment-button">Book an Appointment</router-link>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-4 col-sm-12">
                                    <div class="card border-1 border-radius-8 bg-white h-100 p-0">
                                        <div class="dr-profile border-1 pb-0 border-radius-8">
                                            <div class="doctor-details d-flex mb-3 p-2">
                                                <figure class="text-center">
                                                    <router-link to="/doctor-profile"><img class="mb-4" src="../../../../static/website/images/dr-image.svg" alt="" /></router-link> <i class="icon icon-video"></i>
                                                </figure>
                                                <div>
                                                    <h3>Dr. Shabnam Das Kar</h3>
                                                    <h5>MD, FMNM | 10 Years Exp</h5>
                                                    <p>Specialist in Functional and Metabolic Medicine</p>
                                                </div>
                                            </div>
                                            <router-link to="/calendy-calendar" class="btn btn-link btn-blue appointment-button">Book an Appointment</router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="add-new d-flex justify-content-end mt-3"><router-link to="/doctor-profile" class="btn btn-link btn-text">View All</router-link></div>
                            <ul class="mt-5 d-flex justify-content-between align-items-center consult-menu">
                                <li class="text-center py-3 mr-3 border-radius-5">
                                    <router-link to="/symptom-checker"><img src="../../../../static/website/images/stethoscope.svg" /> <span>Symptom Checker</span></router-link>
                                </li>
                                <li class="text-center py-3 mr-3 border-radius-5">
                                    <router-link to="/medical-records"><img src="../../../../static/website/images/microscope.svg" /> <span>View Medical Records</span></router-link>
                                </li>
                                <li class="text-center py-3 border-radius-5">
                                    <router-link to="/consultation-history"><img src="../../../../static/website/images/Consultations.svg" /> <span>Consultation History</span></router-link>
                                </li>
                            </ul>
                            
                        </div>
                    </div>
                </div>
                <div class="col-12 col-md-5 mb-4">
                    <div class="card border-0 bg-white border-radius-5 h-100">
                        <div class="card-body p-4 questions">
                            <h3 class="mb-3">Ask a questions</h3>
                            <form class="position-relative dropdown">
                                <select class="mb-3">
                                    <option>Dr. Janis Evans</option>
                                </select>
                                <div class="doctor-details chating-room d-flex">
                                    <figure class="text-center position-relative"><img src="../../../../static/website/images/dr-image.svg" alt="" /> <span class="online"></span></figure>
                                    <div class="dr-status">
                                        <h3>Dr. Shabnam Das Kar</h3>
                                        <p>Typing ...</p>
                                    </div>
                                </div>
                                <div class="chat-section">
                                    <h3 class="text-center pb-3">Today</h3>
                                    <p class="patient-chat mb-4">Good Morning Dr. Janis I’m not feeling very well I’ve got these awfu pains in my stomah and i haven’t been sleeping at well</p>
                                    <p class="dr-chat mb-0">You,ve gt some kind of a stomach infection</p>
                                    <span class="d-block">11:22</span>
                                    <p class="dr-chat mb-0">You,ve gt some kind of a stomach infection</p>
                                    <span class="d-block">11:22</span>
                                </div>
                                <div class="textarea position-relative mt-4">
                                    <textarea rows="10" placeholder="Ask Questions from a Doctor..."></textarea>
                                    <button class="button send" type="button"><img src="../../../../static/website/images/send.svg" alt="send" /></button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="questions-section">
            <div class="row mr-0">
                <div class="col-lg-12 col-12 mb-4">
                    <div class="bg-white border-radius-5 p-3">
                        <h2 class="text-center my-4">Related Questions</h2>
                        <form class="form-search position-relative d-flex justify-content-center align-items-center mb-5">
                            <button class="btn button search"><i class="icon icon-search"></i></button>
                            <input type="text" name="text" placeholder="Search Question" />
                        </form>
                        <div class="row no-gutters">
                            <div class="col-lg-4 col-md-4 col-sm-12 mb-5 px-4">
                                <div class="card border-0 h-100">
                                    <div class="card-body p-0 text-left">
                                        <h3><router-link to="/single-post">How often should I get a check-up?</router-link ></h3>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 mb-5 px-4">
                                <div class="card border-0 h-100">
                                    <div class="card-body p-0 text-left">
                                        <h3><router-link to="/single-post">How often should I get a check-up?</router-link ></h3>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 mb-5 px-4">
                                <div class="card border-0 h-100">
                                    <div class="card-body p-0 text-left">
                                        <h3><router-link to="/single-post">How often should I get a check-up?</router-link ></h3>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 mb-5 px-4">
                                <div class="card border-0 h-100">
                                    <div class="card-body p-0 text-left">
                                        <h3><router-link to="/single-post">How often should I get a check-up?</router-link ></h3>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 mb-5 px-4">
                                <div class="card border-0 h-100">
                                    <div class="card-body p-0 text-left">
                                        <h3><router-link to="/single-post">How often should I get a check-up?</router-link ></h3>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 mb-5 px-4">
                                <div class="card border-0 h-100">
                                    <div class="card-body p-0 text-left">
                                        <h3><router-link to="/single-post">How often should I get a check-up?</router-link ></h3>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 mb-5 px-4">
                                <div class="card border-0 h-100">
                                    <div class="card-body p-0 text-left">
                                        <h3><router-link to="/single-post">How often should I get a check-up?</router-link ></h3>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 mb-5 px-4">
                                <div class="card border-0 h-100">
                                    <div class="card-body p-0 text-left">
                                        <h3><router-link to="/single-post">How often should I get a check-up?</router-link ></h3>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4 col-sm-12 mb-5 px-4">
                                <div class="card border-0 h-100">
                                    <div class="card-body p-0 text-left">
                                        <h3><router-link to="/single-post">How often should I get a check-up?</router-link ></h3>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- End of Page Wrapper -->
    </div>
</template>
<script>
    export default {
        name: "make-appointment",
        data() {
            return {};
        },
        created(){
           this.pageName('Consultation')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/appointments/make-appointment.vue